import { render, staticRenderFns } from "./2.vue?vue&type=template&id=3f63b06b&scoped=true&"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=3f63b06b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f63b06b",
  null
  
)

export default component.exports